(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/components/overview-list.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/components/overview-list.js');
"use strict";


const OverviewList = _ref => {
  let _ref$vouchers = _ref.vouchers,
    vouchers = _ref$vouchers === void 0 ? [] : _ref$vouchers,
    campaign = _ref.campaign,
    history = _ref.history,
    toName = _ref.toName,
    message = _ref.message,
    personalGreeting = _ref.personalGreeting,
    _ref$receiverSameAsBu = _ref.receiverSameAsBuyer,
    receiverSameAsBuyer = _ref$receiverSameAsBu === void 0 ? 0 : _ref$receiverSameAsBu;
  const OverviewItemInfo = svs.ticket_gifts.redeem.components.OverviewItemInfo;
  const BubbleInfo = svs.tur.bubbleInfo.components.BubbleInfo;
  const NeedHelp = svs.tur.NeedHelp;
  const Button = svs.ui.Button;
  const _svs$components$Stora = svs.components.Storage,
    browser = _svs$components$Stora.browser,
    EXPIRES_15M = _svs$components$Stora.constants.EXPIRES_15M;
  const _svs$ticket_gifts$con = svs.ticket_gifts.constants,
    TICKETS_DOMAIN = _svs$ticket_gifts$con.TICKETS_DOMAIN,
    TICKETS_KEY = _svs$ticket_gifts$con.TICKETS_KEY;
  const bubbleInfoHeader = svs.ticket_gifts.functions.bubbleInfoHeader;
  const _svs$ticket_gifts$uti = svs.ticket_gifts.utils.campaign.ids,
    _svs$ticket_gifts$uti2 = _svs$ticket_gifts$uti === void 0 ? {} : _svs$ticket_gifts$uti,
    LYCKOPLATSEN = _svs$ticket_gifts$uti2.LYCKOPLATSEN;
  const totalPrice = svs.utils.format.Currency(vouchers.reduce((acc, voucher) => acc + parseInt(voucher.ticketPrice, 10), 0));
  const numberOfTickets = vouchers.length;
  const vouchersInfo = "".concat(numberOfTickets, " ").concat(numberOfTickets > 1 ? 'lotter' : 'lott', " till ett v\xE4rde av ").concat(totalPrice, " kr");
  const playLink = giftCode => history && history.push("".concat(history.location.pathname, "/spela/").concat(giftCode));
  const getGameCodeForVoucher = voucher => {
    var _svs$ticket_gifts$cho, _svs$ticket_gifts$gam;
    return ((_svs$ticket_gifts$cho = svs.ticket_gifts.chooseGameForVoucher(voucher)) === null || _svs$ticket_gifts$cho === void 0 ? void 0 : _svs$ticket_gifts$cho.type) || ((_svs$ticket_gifts$gam = svs.ticket_gifts.games) === null || _svs$ticket_gifts$gam === void 0 || (_svs$ticket_gifts$gam = _svs$ticket_gifts$gam.find(game => game.voucherId === (voucher === null || voucher === void 0 ? void 0 : voucher.voucherConfigId))) === null || _svs$ticket_gifts$gam === void 0 ? void 0 : _svs$ticket_gifts$gam.type);
  };

  const handleVoucherClick = giftCode => {
    const clickedVoucher = vouchers.find(voucher => voucher.giftCode === giftCode);
    const gameCode = getGameCodeForVoucher(clickedVoucher);
    if (gameCode) {
      svs.ticketgames.ticketUtility.utils.tracking.trackScratchTicket(gameCode, 1);
    }
    const unredeemed = vouchers.filter(voucher => !voucher.isRedeemed);
    const last = unredeemed.splice(0, _.findIndex(unredeemed, voucher => voucher.giftCode === giftCode));
    browser.set(TICKETS_KEY, TICKETS_DOMAIN, [...unredeemed, ...last], EXPIRES_15M);
    playLink(giftCode);
  };
  const handlePlayAllClick = e => {
    e && e.preventDefault();
    const unredeemed = vouchers.filter(voucher => !voucher.isRedeemed);
    if (!unredeemed.length) {
      return;
    }
    browser.set(TICKETS_KEY, TICKETS_DOMAIN, unredeemed, EXPIRES_15M);
    const gameCode = getGameCodeForVoucher(unredeemed[0]);
    gameCode && svs.ticketgames.ticketUtility.utils.tracking.trackScratchTicket(gameCode, unredeemed.length);
    playLink(unredeemed[0].giftCode);
  };
  const allRedeemed = vouchers.reduce((c, n) => c && n.isRedeemed, true);
  const activeVoucherCount = vouchers.filter(voucher => !voucher.isRedeemed).length;
  return React.createElement("div", {
    className: "padding-1 tg-container w100 f-body",
    "data-testid": "overview-list"
  }, React.createElement("div", {
    className: "padding-top-2"
  }, receiverSameAsBuyer ? React.createElement("div", {
    className: "padding-h-2"
  }, React.createElement("h1", {
    className: "h1 f-center tg-overview-list-header"
  }, vouchersInfo)) : React.createElement(BubbleInfo, {
    className: "bubble-info-container",
    header: bubbleInfoHeader(personalGreeting, toName)
  }, message)), campaign !== LYCKOPLATSEN && vouchers.length > 0 && !allRedeemed && !receiverSameAsBuyer && React.createElement("h2", {
    className: "h2 padding-top-1 margin-bottom-1"
  }, vouchersInfo), campaign === LYCKOPLATSEN && React.createElement("div", {
    className: "padding-1"
  }), !vouchers.length || allRedeemed ? React.createElement("p", {
    className: "p"
  }, "Alla lotter \xE4r inl\xF6sta. Se resultatet i", ' ', React.createElement("a", {
    className: "qa-redirect-to-mina-sidor-a",
    href: svs.core.urlMapping.get('myBetsHome')
  }, "Mina spel.")) : React.createElement(React.Fragment, null, campaign !== LYCKOPLATSEN && React.createElement("p", {
    className: "p margin-bottom-1"
  }, "Du kan v\xE4lja att skrapa alla lotterna efter varandra eller en och en."), React.createElement("div", {
    className: "margin-bottom-2"
  }, React.createElement(Button, {
    block: true,
    className: "qa-play-tickets play-all-btn",
    "data-testid": activeVoucherCount === 1 ? 'qa-play-single-ticket' : 'qa-play-all-tickets',
    focus: true,
    onClick: handlePlayAllClick
  }, activeVoucherCount === 1 ? 'Skrapa lott' : 'Skrapa alla lotter'))), React.createElement("div", {
    className: "overview-list margin-bottom-2",
    "data-testid": "vouchers"
  }, vouchers.sort((a, b) => Boolean(b.availableOnline) - Boolean(a.availableOnline)).sort((a, b) => Boolean(a.isRedeemed) - Boolean(b.isRedeemed)).map(voucher => React.createElement(OverviewItemInfo, {
    campaign: voucher.campaign,
    isRedeemed: voucher.isRedeemed,
    key: "overview_list_".concat(voucher.giftCode),
    onClick: handleVoucherClick,
    ticketImg: voucher.img,
    ticketName: voucher.ticketName,
    ticketPrice: voucher.ticketPrice,
    voucherCode: voucher.giftCode
  }))), React.createElement(NeedHelp, null));
};
setGlobal('svs.ticket_gifts.redeem.components.OverviewList', OverviewList);

 })(window);